{
  "name": "@jspsych-contrib/plugin-tower-of-london",
  "version": "1.0.0",
  "description": "A jsPsych plugin for Tower of London/Hanoi style puzzle tasks. Participants move colored balls between pegs to match a goal configuration.",
  "type": "module",
  "main": "dist/index.cjs",
  "exports": {
    "import": "./dist/index.js",
    "require": "./dist/index.cjs"
  },
  "typings": "dist/index.d.ts",
  "unpkg": "dist/index.browser.min.js",
  "files": [
    "src",
    "dist"
  ],
  "source": "src/index.ts",
  "scripts": {
    "test": "jest",
    "test:watch": "npm test -- --watch",
    "tsc": "tsc",
    "build": "rollup --config",
    "build:watch": "npm run build -- --watch"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/jspsych/jspsych-contrib.git",
    "directory": "packages/plugin-tower-of-london"
  },
  "keywords": [
    "jsPsych",
    "tower-of-london",
    "tower-of-hanoi",
    "executive-function",
    "planning",
    "problem-solving"
  ],
  "author": {
    "name": "Josh de Leeuw",
    "url": "https://github.com/jodeleeuw"
  },
  "license": "MIT",
  "bugs": {
    "url": "https://github.com/jspsych/jspsych-contrib/issues"
  },
  "homepage": "https://github.com/jspsych/jspsych-contrib/tree/main/packages/plugin-tower-of-london",
  "peerDependencies": {
    "jspsych": ">=8.0.0"
  },
  "devDependencies": {
    "@jspsych/config": "^3.2.2",
    "@jspsych/test-utils": "^1.0.0",
    "jspsych": "^8.0.0"
  }
}
